import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const HonkFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M2.09998 5.06348H5.76484V5.96348C5.76484 6.79295 5.97493 7.72884 6.52274 8.43611C7.03936 9.10312 7.93923 9.67637 9.5757 9.67637H20.1V7.50024H21.9L21.9 17.1369H20.1V14.3346H17C16.7155 16.2274 15.2783 17.828 13.3333 17.828C11.3883 17.828 9.95107 16.2274 9.66663 14.3346H9.5757C7.93788 14.3346 7.03803 14.9062 6.522 15.5705C5.97493 16.2747 5.76494 17.2073 5.76494 18.0366V18.9366H2.10009L2.09998 5.06348ZM13.3333 16.028C12.5557 16.028 11.7458 15.3838 11.4943 14.3346H15.1723C14.9208 15.3838 14.1109 16.028 13.3333 16.028Z"
      />
    </SvgIcon>
  );
});
